// Warms a route's lazy-loaded JS chunk before the user clicks, so navigation
// to a code-split page feels instant. Uses the same dynamic-import specifiers
// as App.js — webpack dedupes them to the same chunk, so React.lazy resolves
// from cache the moment the user actually navigates.
const loaders = {
  "/jobs": () => import("@/pages/Jobs"),
  "/pricing": () => import("@/pages/Pricing"),
  "/dashboard": () => import("@/pages/LaborerDashboard"),
  "/search": () => import("@/pages/HirerSearch"),
  "/inbox": () => import("@/pages/Inbox"),
  "/my-jobs": () => import("@/pages/MyJobs"),
  "/my-applications": () => import("@/pages/MyApplications"),
  "/post-job": () => import("@/pages/PostJob"),
  "/referrals": () => import("@/pages/Referrals"),
  "/account": () => import("@/pages/Account"),
  "/admin": () => import("@/pages/Admin"),
  "/refer-and-earn": () => import("@/pages/ReferAndEarn"),
  "/cities": () => import("@/pages/CityDirectory"),
  "/affiliate": () => import("@/pages/AffiliateDashboard"),
  "/login": () => import("@/pages/Auth"),
  "/signup": () => import("@/pages/Auth"),
};

const warmed = new Set();

export function prefetchRoute(path) {
  const load = loaders[path];
  if (!load || warmed.has(path)) return;
  warmed.add(path);
  load().catch(() => warmed.delete(path));
}
